function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { arrayMove } from '@dnd-kit/sortable';
import { GridRange, GridUtils } from '@deephaven/grid';
import { assertNotNull } from '@deephaven/utils';
import { isFlattenedTreeItem } from "./types.js";
/**
 * Gets the depth of an item dragged with a given x-axis offset
 *
 * @param offset x-axis offset of the dragging item
 * @param indentationWidth Width of indentation for each depth
 * @returns The drag depth for the given offset
 */
function getDragDepth(offset, indentationWidth) {
  return Math.round(offset / indentationWidth);
}
function getTreeItem(nameToIndexes, movedColumns, columnHeaderGroupMap, name, hiddenColumnSet, selectedItems, showHiddenColumns) {
  var _nameToIndexes$get;
  var _ref = (_nameToIndexes$get = nameToIndexes.get(name)) !== null && _nameToIndexes$get !== void 0 ? _nameToIndexes$get : {},
    modelIndex = _ref.modelIndex,
    visibleIndex = _ref.visibleIndex;
  if (modelIndex === undefined || visibleIndex === undefined) {
    var group = columnHeaderGroupMap.get(name);
    if (group == null) {
      throw new Error("Column or header group not found: ".concat(name));
    }
    var modelIndexes = group.childIndexes.flat();
    return {
      id: name,
      selected: selectedItems.has(name),
      children: group.children.filter((_, i) => showHiddenColumns || !hiddenColumnSet.has(group.childIndexes[i])).map(childName => getTreeItem(nameToIndexes, movedColumns, columnHeaderGroupMap, childName, hiddenColumnSet, selectedItems, showHiddenColumns)).sort((a, b) => {
        var aVal = Array.isArray(a.data.visibleIndex) ? a.data.visibleIndex[0] : a.data.visibleIndex;
        var bVal = Array.isArray(b.data.visibleIndex) ? b.data.visibleIndex[0] : b.data.visibleIndex;
        return aVal - bVal;
      }),
      data: {
        modelIndex: modelIndexes,
        visibleIndex: group.getVisibleRange(movedColumns),
        group,
        isVisible: modelIndexes.some(index => !hiddenColumnSet.has(index))
      }
    };
  }
  return {
    id: name,
    children: [],
    selected: selectedItems.has(name),
    data: {
      modelIndex,
      visibleIndex,
      isVisible: !hiddenColumnSet.has(modelIndex)
    }
  };
}
export function getTreeItems(columns, movedColumns, columnHeaderGroups, hiddenColumns, selectedItems, showHiddenColumns) {
  var items = [];
  var selectedItemsSet = new Set(selectedItems);
  var groupMap = new Map(columnHeaderGroups.map(group => [group.name, group]));
  var hiddenColumnSet = new Set(hiddenColumns);
  var visibleIndex = 0;
  var modelRanges = GridRange.boundedRanges(GridUtils.getModelRange(GridRange.makeNormalized(0, 0, columns.length - 1, 0), movedColumns), columns.length, 1);
  var mapEntries = modelRanges.flatMap(range => {
    var startColumn = range.startColumn,
      endColumn = range.endColumn;
    var rangeLength = endColumn - startColumn + 1;
    var entries = new Array(rangeLength).fill(0).map((_, i) => [visibleIndex + i, startColumn + i]);
    visibleIndex += rangeLength;
    return entries;
  });
  var visibleToModelMap = new Map(mapEntries);
  var nameToIndexes = new Map([...visibleToModelMap.entries()].map(_ref2 => {
    var _ref3 = _slicedToArray(_ref2, 2),
      v = _ref3[0],
      m = _ref3[1];
    return [columns[m].name, {
      visibleIndex: v,
      modelIndex: m
    }];
  }));
  visibleIndex = 0;
  var _loop = function _loop() {
    var modelIndex = visibleToModelMap.get(visibleIndex);
    assertNotNull(modelIndex);
    var columnName = columns[modelIndex].name;
    var group = columnHeaderGroups.find(_ref4 => {
      var children = _ref4.children;
      return children.includes(columnName);
    });
    while (group !== undefined && group.parent !== undefined) {
      group = groupMap.get(group.parent);
    }
    var item = getTreeItem(nameToIndexes, movedColumns, groupMap, group ? group.name : columnName, hiddenColumnSet, selectedItemsSet, showHiddenColumns);
    items.push(item);
    if (Array.isArray(item.data.visibleIndex)) {
      visibleIndex += item.data.visibleIndex[1] - item.data.visibleIndex[0] + 1;
    } else {
      visibleIndex += 1;
    }
  };
  while (visibleIndex < columns.length) {
    _loop();
  }
  return items;
}

/**
 * Gets the projected drop position and depth of the dragged item
 *
 * @param items List of flattened items
 * @param activeId ID of the actively dragged item
 * @param overId ID of the item currently being dragged over
 * @param dragOffset The x-axis offset of the dragged item
 * @param indentationWidth The width for each level of the tree
 * @returns The projected position and depth if the item were to be dropped.
 *          Null if the projection could not be calculated.
 */
export function getProjection(items, activeId, overId, dragOffset, indentationWidth) {
  var overItemIndex = items.findIndex(_ref5 => {
    var id = _ref5.id;
    return id === overId;
  });
  var activeItemIndex = items.findIndex(_ref6 => {
    var id = _ref6.id;
    return id === activeId;
  });
  if (overItemIndex === -1 || activeItemIndex === -1) {
    return null;
  }
  var activeItem = items[activeItemIndex];
  var newItems = arrayMove(items, activeItemIndex, overItemIndex);
  var previousItem = newItems[overItemIndex - 1];
  var nextItem = newItems[overItemIndex + 1];
  var dragDepth = getDragDepth(dragOffset, indentationWidth);
  var projectedDepth = activeItem.depth + dragDepth;
  var maxDepth = getMaxDepth({
    previousItem,
    nextItem
  });
  var minDepth = getMinDepth({
    nextItem
  });
  var depth = projectedDepth;
  if (projectedDepth >= maxDepth) {
    depth = maxDepth;
  } else if (projectedDepth < minDepth) {
    depth = minDepth;
  }
  return {
    depth,
    maxDepth,
    minDepth,
    parentId: getParentId()
  };
  function getParentId() {
    var _newItems$slice$rever;
    if (depth === 0 || !previousItem) {
      return null;
    }
    if (depth === previousItem.depth) {
      return previousItem.parentId;
    }
    if (depth > previousItem.depth) {
      return previousItem.id;
    }
    var newParent = (_newItems$slice$rever = newItems.slice(0, overItemIndex).reverse().find(item => item.depth === depth)) === null || _newItems$slice$rever === void 0 ? void 0 : _newItems$slice$rever.parentId;
    return newParent !== null && newParent !== void 0 ? newParent : null;
  }
}
function getMaxDepth(_ref7) {
  var _previousItem$depth, _nextItem$depth;
  var previousItem = _ref7.previousItem,
    nextItem = _ref7.nextItem;
  return Math.max((_previousItem$depth = previousItem === null || previousItem === void 0 ? void 0 : previousItem.depth) !== null && _previousItem$depth !== void 0 ? _previousItem$depth : 0, (_nextItem$depth = nextItem === null || nextItem === void 0 ? void 0 : nextItem.depth) !== null && _nextItem$depth !== void 0 ? _nextItem$depth : 0);
}
function getMinDepth(_ref8) {
  var nextItem = _ref8.nextItem;
  if (nextItem) {
    return nextItem.depth;
  }
  return 0;
}

/**
 * Helper function to recursively flatten a tree
 *
 * @param items Items to flatten
 * @param parentId The current parentId of the items
 * @param depth The current depth of the items
 * @returns Flattened items
 */
function flatten(items) {
  var parentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return items.reduce((acc, item) => [...acc, _objectSpread(_objectSpread({}, item), {}, {
    parentId,
    depth,
    index: 0
  }),
  // Index will be recalculated after
  ...flatten(item.children, item.id, depth + 1)], []).map((item, index) => _objectSpread(_objectSpread({}, item), {}, {
    index
  })); // Recalculate indexes to be sequential
}

/**
 * Flattens a tree into a 1D array given the items
 * @param items The tree items to flatten
 * @returns The flattened tree items list
 */
export function flattenTree(items) {
  // Should help prevent double flattening since FlattenedItems are valid TreeItems
  if (items.every(isFlattenedTreeItem)) {
    return [...items];
  }
  return flatten(items);
}

/**
 * Recursively checks for the item in a list of items.
 * The list does not have to be flattened prior to searching.
 *
 * @param items Items to search
 * @param itemId Item to find
 * @returns The item if found
 */
export function findItemDeep(items, itemId) {
  for (var i = 0; i < items.length; i += 1) {
    var item = items[i];
    var id = item.id,
      children = item.children;
    if (id === itemId) {
      return item;
    }
    if (children.length) {
      var child = findItemDeep(children, itemId);
      if (child) {
        return child;
      }
    }
  }
  return undefined;
}
function countChildren(items) {
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return items.reduce((acc, _ref9) => {
    var children = _ref9.children;
    if (children.length) {
      return countChildren(children, acc + 1);
    }
    return acc + 1;
  }, count);
}
export function getChildCount(items, id) {
  var item = findItemDeep(items, id);
  return item ? countChildren(item.children) : 0;
}

/**
 * Removes the children of the list of parents from the list of flattened items
 *
 * @param items The flattened items to remove from
 * @param ids The parents we want to remove the children of
 * @returns The flattened items without the children of the parents
 */
export function removeChildrenOf(items, ids) {
  var excludeParentIds = new Set(ids);
  return items.filter(item => {
    if (item.parentId != null && excludeParentIds.has(item.parentId)) {
      if (item.children.length) {
        excludeParentIds.add(item.id);
      }
      return false;
    }
    return true;
  });
}
//# sourceMappingURL=utilities.js.map